import axios from '../../utils/axios';

export default function fetchLGBills(adminId, params = {}) {
    return (
        axios.get('/admin/'+adminId+'/allLGBills', {params})
    )
}
